import service from '@/plugins/service'

const base = '/auth/kingdee/'

export const getJDYOrganizations = () => service({
  url: `${base}list/org`,
  method: 'GET'
})

export const getJDYDepartments = (params) => service({
  url: `${base}list/dept`,
  method: 'GET',
  params
})